import axios from "axios";
import { NETWORK_ERROR_MESSAGE, isNetworkFailureMessage } from "./apiError";

export const api = axios.create({
  baseURL: "https://api.niqsng.org/api",
});

// Auto-attach bearer token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// No response at all (dropped connection, timeout, cancelled request): axios
// reports "Network Error" / "canceled". Callers fall back to err.message, so
// give them the same member-facing wording every other layer uses.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      !error?.response &&
      isNetworkFailureMessage(`${error?.code ?? ""} ${error?.name ?? ""} ${error?.message ?? ""}`)
    ) {
      error.message = NETWORK_ERROR_MESSAGE;
    }
    return Promise.reject(error);
  },
);

export default api;
